<template>
  <div id="pnavWrap">
    <div class="inner_static">
      <div id="pnav_header">
        <h1 id="pnav_logo" class="pnav_logo_h1">
          <strong>カグル.</strong>
        </h1>
        <a id="btn_close_pnav" @click="btnCloseClick()"></a>
      </div>
      <nav id="pnav">
        <ul>
          <li>
            <a @click="logout()">ログイン（ログアウト）</a>
          </li>
          <li>
            <a @click="myPage()">マイページ</a>
          </li>
          <li>
            <a @click="planning()">プランを作る</a>
          </li>
          <li>
            <a @click="search()">プラン検索</a>
          </li>
          <li>
            <a @click="news()">NEWS</a>
          </li>
          <li>
            <a>キャンペーン</a>
          </li>
          <li>
            <a @click="about()">ABOUT</a>
          </li>
          <li>
            <a>アプリの使い方</a>
          </li>
          <li>
            <a @click="questions()">よくある質問</a>
          </li>
          <li v-if="user && user.userId === 238">
            <a @click="survey()">アンケート</a>
          </li>
        </ul>
      </nav>
      <kg-footer
        :toContactEventFlg="true"
        @toContactEvent="toContact()"/>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import * as App from '../../../utils/App'
import * as Api from '../../../utils/Api'

// Module
import {KG_URL, KG_STORAGE_KEY} from '../../../constants/App'

import Footer from '../../components/login/LoginFooter'

export default {
  name: 'KgMenu',
  components: {
    'kg-footer': Footer
  },
  data () {
    return {
      errorMessage: { text: '' },
      validateErrorMessages: {},
      user: {}
    }
  },
  methods: {
    top: function () {
      // トップ画面遷移
      this.btnCloseClick()
      this.$router.push('/kagull/top')
    },
    logout: function () {
      // ログアウト処理
      this.btnCloseClick()
      axios.post(KG_URL.TOP + '/logout', {}
      ).then(response => {
        if (response.data.errorMessage) {
          this.handleErrorMessage(response)
        } else {
          App.removeLocalStorage(KG_STORAGE_KEY.USER_INFO)
          App.removeLocalStorage(KG_STORAGE_KEY.SAVE_PLAN)
          this.$router.push('/kagull/login')
        }
      }).catch(error => {
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      })
    },
    myPage: function () {
      // マイページ遷移
      this.btnCloseClick()
      this.$router.push('/kagull/mypage')
    },
    planning: function () {
      // 家具製作画面遷移
      this.btnCloseClick()
      this.$router.push('/kagull/planning/category')
    },
    search: function () {
      // プラン検索
      this.btnCloseClick()
      this.$emit('toSearchEvent')
    },
    survey: function () {
      // アンケート入力画面遷移（デバッグ用）
      this.btnCloseClick()
      this.$router.push('/kagull/survey/input')
    },
    news: function () {
      // ニュース一覧画面遷移
      this.btnCloseClick()
      this.$router.push('/kagull/news')
    },
    about: function () {
      // ABOUT画面遷移
      this.btnCloseClick()
      this.$router.push('/kagull/about/1')
    },
    questions: function () {
      // FAQ遷移
      this.btnCloseClick()
      this.$router.push('/kagull/faq/1')
    },
    btnCloseClick: function () {
      // メニューを閉じる
      this.$emit('menuCloseEvent')
    },
    toContact: function () {
      // お問い合わせ画面遷移
      this.btnCloseClick()
      this.$router.push('/kagull/support/input/1')
    }
  },
  created: function () {
    this.user = App.getLocalStorage(KG_STORAGE_KEY.USER_INFO)
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/components/common/KgMenu.vue